import { _freeze, } from '../util/data';
import { _createId, } from '../service/id-set';
const _routePanes = ($map) => {
    const routeIdNum = _createId(), routeId = routeIdNum.toString(), linePaneId = `line-${routeId}`, markerPaneId = `marker-${routeId}`, $linePane = $map.getPane(linePaneId) || $map.createPane(linePaneId), $markerPane = $map.getPane(markerPaneId) || $map.createPane(markerPaneId);
    $linePane.style.zIndex = _zIndexForLinePane;
    $markerPane.style.zIndex = _zIndexForMarkerPane;
    return _freeze({
        idn: () => routeIdNum,
        id: () => routeId,
        lid: () => linePaneId,
        mid: () => markerPaneId,
        lp: () => $linePane,
        mp: () => $markerPane,
    });
}, _zIndexForLinePane = '400', _zIndexForMarkerPane = '600';
export { _routePanes, };
